/* Test A/B pe header.
 *
 * Statsig decide varianta. Noi doar o oglindim intr-un cookie, ca paginile
 * urmatoare sa se poata picta sincron, din scriptul inline din <head>, fara sa
 * astepte reteaua. Cookie-ul NU decide nimic — retine ce a decis Statsig.
 *
 * Expunerea se logheaza prin getExperiment, nu din cookie: altfel am fi numarat
 * o singura expunere pentru un vizitator care revine de zece ori.
 *
 * Regula de baza, ca si la lnx-video-widget.js: nimic de aici n-are voie sa
 * arunce o eroare care sa opreasca pagina.
 */
(function () {
  'use strict';

  var EXPERIMENT = 'ergoliv_header_v2';
  var COOKIE = 'ergoliv_ab_header';
  /* Cat asteptam raspunsul Statsig inainte sa numim cazul „fallback". La rece —
     vizitator nou, fara cache — Statsig trebuie sa incarce scriptul SI sa faca
     cererea de retea, ceea ce depaseste regulat 1,5s. Masurat pe live: raspuns
     „Test/b" sosit dupa ce codul cazuse deja pe control. */
  var TIMEOUT_MS = 6000;
  var DESKTOP = 990;

  var root = document.documentElement;

  function readCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function writeCookie(name, value) {
    try {
      document.cookie =
        name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + 60 * 60 * 24 * 365 + '; SameSite=Lax';
    } catch (e) {
      /* ignoram */
    }
  }

  function track(name, value, meta) {
    try {
      if (typeof window.ergolivTrack === 'function') window.ergolivTrack(name, value, meta || {});
    } catch (e) {
      /* ignoram */
    }
  }

  /* ---- aplicarea variantei ------------------------------------------- */

  function mount() {
    /* sub 990px header-ul nou e ascuns oricum: nu-l mai clonam degeaba pe
       telefoane, care sunt 58% din trafic si nu fac parte din test */
    if (window.innerWidth < DESKTOP) return false;
    if (document.querySelector('.abh')) return true;
    var tpl = document.getElementById('abHeaderV2');
    var wrapper = document.querySelector('.header-wrapper');
    if (!tpl || !wrapper || !tpl.content) return false;
    wrapper.appendChild(tpl.content.cloneNode(true));
    return true;
  }

  function apply(variant) {
    root.setAttribute('data-ab-header', variant);
    if (variant === 'b') mount();
    syncHeaderHeight();
  }

  /* sticky-header.js masoara .section-header o singura data, la conectare.
     Daca schimbam header-ul dupa aceea, --header-height ramane gresit si tot
     ce se lipeste sub el (bara de filtre din colectii) sare. */
  function syncHeaderHeight() {
    try {
      var h = document.querySelector('.section-header');
      if (h && h.offsetHeight) root.style.setProperty('--header-height', h.offsetHeight + 'px');
    } catch (e) {
      /* ignoram */
    }
  }

  /* ---- Statsig --------------------------------------------------------- */

  function statsigClient() {
    try {
      var S = window.__STATSIG__;
      var c = S && typeof S.instance === 'function' ? S.instance() : null;
      return c && typeof c.getExperiment === 'function' ? c : null;
    } catch (e) {
      return null;
    }
  }

  function resolve() {
    /* Sub 990px varianta B nici nu se afiseaza. Daca am cere varianta si aici,
       am loga o expunere pentru un vizitator care vede controlul — si cum 58%
       din trafic e mobil, am dilua efectul pana la invizibil. */
    if (window.innerWidth < DESKTOP) return;

    var started = Date.now();
    var decis = false; // am primit raspuns de la Statsig
    var aplicat = null; // ce am pictat deja

    function aplica(variant) {
      if (aplicat === variant) return;
      aplicat = variant;
      writeCookie(COOKIE, variant);
      apply(variant);
    }

    (function poll() {
      var c = statsigClient();
      if (c) {
        var v = 'a';
        var alocat = false;
        try {
          var exp = c.getExperiment(EXPERIMENT);
          /* `groupName` null inseamna „inca nu e alocat" — experiment nepornit
             sau evaluare din cache, inainte sa vina configul de pe retea.
             Daca am citi `variant` acum, am primi fallback-ul si am inchide
             subiectul cu raspunsul gresit. */
          alocat = !!(exp && exp.groupName);
          if (alocat) v = exp.get('variant', 'a') === 'b' ? 'b' : 'a';
        } catch (e) {
          alocat = false;
        }

        if (alocat) {
          decis = true;
          /* Corectie tarzie: daca intre timp pictasem controlul ca sa nu tinem
             pagina goala, si Statsig spune „b", trecem pe b acum. Mai bine o
             schimbare vizibila o data decat un brat de test contaminat. */
          return aplica(v);
        }
      }

      if (Date.now() - started >= TIMEOUT_MS) {
        if (!decis) {
          aplica('a');
          track('header_ab_fallback', 'a', { ms: String(Date.now() - started) });
        }
        return;
      }
      window.setTimeout(poll, 100);
    })();
  }

  /* ---- interactiuni ---------------------------------------------------- */

  function wire() {
    /* mega meniul se deschide la hover pe desktop, dar ramane <details> ca sa
       functioneze si la tastatura. */
    document.addEventListener(
      'mouseover',
      function (e) {
        if (window.innerWidth < DESKTOP) return;
        var t = e.target;
        if (!t || !t.closest) return;
        var item = t.closest('.abh__nav-item');
        var nav = t.closest('.abh__nav');
        if (!nav) return;
        Array.prototype.forEach.call(document.querySelectorAll('.abh__disclosure[open]'), function (d) {
          if (!item || !item.contains(d)) d.removeAttribute('open');
        });
        if (item) {
          var d = item.querySelector('.abh__disclosure');
          if (d) d.setAttribute('open', '');
        }
      },
      true
    );

    document.addEventListener('mouseleave', closeAll, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    function closeAll(e) {
      if (e && e.target && e.target.closest && !e.target.closest('.abh')) return;
      if (e && e.target !== document.querySelector('.abh')) return;
      Array.prototype.forEach.call(document.querySelectorAll('.abh__disclosure[open]'), function (d) {
        d.removeAttribute('open');
      });
    }

    /* ---- metricile testului ---- */

    document.addEventListener(
      'submit',
      function (e) {
        try {
          var f = e.target;
          if (!f || !f.closest) return;
          /* Metrica de decizie a testului. Trebuie sa se logheze in AMBELE brate,
             altfel n-avem cu ce compara: in B e formularul din bara, in control e
             cel din modalul deschis de iconita. Formularul din pagina de
             rezultate nu intra — nu e header. */
          var inB = f.classList.contains('abh__search');
          var inControl = !!f.closest('.header') && f.matches('form[action*="/search"]');
          if (!inB && !inControl) return;
          var q = f.querySelector('input[name="q"]');
          track('header_search', (q && q.value ? q.value : '').slice(0, 60), {
            variant: current(),
            sursa: inB ? 'bara' : 'modal'
          });
        } catch (err) {
          /* ignoram */
        }
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        try {
          var t = e.target;
          if (!t || !t.closest) return;
          if (t.closest('[data-abh-phone]') || t.closest('a[href^="tel:"]')) {
            return track('header_phone_click', location.pathname, { variant: current() });
          }
          var inNav = t.closest('.abh__nav') || t.closest('.header__inline-menu');
          if (inNav) {
            var a = t.closest('a');
            if (a) {
              return track('header_nav_click', a.getAttribute('href') || '', {
                variant: current(),
                eticheta: (a.textContent || '').trim().slice(0, 40)
              });
            }
          }
          /* in bratul de control, cautarea e o iconita care deschide un modal */
          if (t.closest('.header__search') || t.closest('details-modal .search__input')) {
            return track('header_search_open', 'control', { variant: current() });
          }
        } catch (err) {
          /* ignoram */
        }
      },
      true
    );
  }

  function current() {
    return root.getAttribute('data-ab-header') || 'necunoscut';
  }

  /* ---- pornire --------------------------------------------------------- */

  function boot() {
    /* pentru QA: ?ab_header=a|b fixeaza varianta si scrie cookie-ul */
    var forced = '';
    try {
      forced = new URLSearchParams(location.search).get('ab_header') || '';
    } catch (e) {
      /* ignoram */
    }
    if (forced === 'a' || forced === 'b') {
      writeCookie(COOKIE, forced);
      apply(forced);
    } else {
      var known = readCookie(COOKIE);
      if (known === 'a' || known === 'b') {
        apply(known);
        /* expunerea se logheaza la fiecare afisare, nu doar la prima — dar tot
           numai pe desktop, unde varianta chiar se vede */
        var c = window.innerWidth >= DESKTOP ? statsigClient() : null;
        if (c) {
          try {
            c.getExperiment(EXPERIMENT);
          } catch (e) {
            /* ignoram */
          }
        }
      } else {
        resolve();
      }
    }
    wire();
    window.addEventListener('resize', syncHeaderHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
